import { render, staticRenderFns } from "./SaveContract.vue?vue&type=template&id=1dac4e74&scoped=true"
import script from "./SaveContract.vue?vue&type=script&lang=js"
export * from "./SaveContract.vue?vue&type=script&lang=js"
import style0 from "./SaveContract.vue?vue&type=style&index=0&id=1dac4e74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dac4e74",
  null
  
)

export default component.exports